<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="groupId" >
        <span slot="label" ><a-tooltip>{{ $t('小组ID，外键{community_group.id}') }}<template slot="title">{{ $t('小组ID，外键{community_group.id}') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.groupId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'小组ID，外键{community_group.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" ><a-tooltip>{{ $t('发布用户ID，外键{user_user.id}') }}<template slot="title">{{ $t('发布用户ID，外键{user_user.id}') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'发布用户ID，外键{user_user.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="postTitle" >
        <span slot="label" ><a-tooltip>{{ $t('帖子标题') }}<template slot="title">{{ $t('帖子标题') }}</template></a-tooltip> </span>
        <a-input v-model="form.postTitle" :maxLength="128" :placeholder="$t('请输入')+'帖子标题'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="postContent" >
        <span slot="label" ><a-tooltip>{{ $t('帖子正文') }}<template slot="title">{{ $t('帖子正文') }}</template></a-tooltip> </span>
        <editor v-model="form.postContent" />
      </a-form-model-item>
      <a-form-model-item prop="postType" >
        <span slot="label" ><a-tooltip>{{ $t('帖子类型：10-文字，20-图文，30-视频') }}<template slot="title">{{ $t('帖子类型：10-文字，20-图文，30-视频') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="postStatus" >
        <span slot="label" ><a-tooltip>{{ $t('帖子状态：1010-正常，1020-待审核，1030-审核拒绝，1040-已下架') }}<template slot="title">{{ $t('帖子状态：1010-正常，1020-待审核，1030-审核拒绝，1040-已下架') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="coverUrl" >
        <span slot="label" ><a-tooltip>{{ $t('帖子封面URL，图文取首图，视频取封面') }}<template slot="title">{{ $t('帖子封面URL，图文取首图，视频取封面') }}</template></a-tooltip> </span>
        <a-input v-model="form.coverUrl" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="addressAreaId" >
        <span slot="label" ><a-tooltip>{{ $t('区域ID') }}<template slot="title">{{ $t('区域ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.addressAreaId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'区域ID'" />
      </a-form-model-item>
      <a-form-model-item prop="addressDetail" >
        <span slot="label" ><a-tooltip>{{ $t('详细地址') }}<template slot="title">{{ $t('详细地址') }}</template></a-tooltip> </span>
        <a-input v-model="form.addressDetail" :maxLength="255" :placeholder="$t('请输入')+'详细地址'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="addressLongitude" >
        <span slot="label" ><a-tooltip>{{ $t('定位经度') }}<template slot="title">{{ $t('定位经度') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="addressLatitude" >
        <span slot="label" ><a-tooltip>{{ $t('定位纬度') }}<template slot="title">{{ $t('定位纬度') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="viewNum" >
        <span slot="label" ><a-tooltip>{{ $t('浏览数量') }}<template slot="title">{{ $t('浏览数量') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.viewNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'浏览数量'" />
      </a-form-model-item>
      <a-form-model-item prop="starNum" >
        <span slot="label" ><a-tooltip>{{ $t('点赞数量') }}<template slot="title">{{ $t('点赞数量') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.starNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'点赞数量'" />
      </a-form-model-item>
      <a-form-model-item prop="replyNum" >
        <span slot="label" ><a-tooltip>{{ $t('评论数量') }}<template slot="title">{{ $t('评论数量') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.replyNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'评论数量'" />
      </a-form-model-item>
      <a-form-model-item prop="collectionNum" >
        <span slot="label" ><a-tooltip>{{ $t('收藏数量') }}<template slot="title">{{ $t('收藏数量') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.collectionNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'收藏数量'" />
      </a-form-model-item>
      <a-form-model-item prop="shareNum" >
        <span slot="label" ><a-tooltip>{{ $t('分享数量') }}<template slot="title">{{ $t('分享数量') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.shareNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'分享数量'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsNum" >
        <span slot="label" ><a-tooltip>{{ $t('关联商品数量') }}<template slot="title">{{ $t('关联商品数量') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.goodsNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'关联商品数量'" />
      </a-form-model-item>
      <a-form-model-item prop="isTop" >
        <span slot="label" ><a-tooltip>{{ $t('是否置顶：1-是，0-否') }}<template slot="title">{{ $t('是否置顶：1-是，0-否') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="isRecommend" >
        <span slot="label" ><a-tooltip>{{ $t('是否推荐：1-是，0-否') }}<template slot="title">{{ $t('是否推荐：1-是，0-否') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="auditReason" >
        <span slot="label" ><a-tooltip>{{ $t('审核/下架原因') }}<template slot="title">{{ $t('审核/下架原因') }}</template></a-tooltip> </span>
        <a-input v-model="form.auditReason" :maxLength="255" :placeholder="$t('请输入')+'审核/下架原因'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupPost, addCommunityGroupPost, updateCommunityGroupPost } from '@/api/community/communityGroup/communityGroupPost'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

      import Editor from '@/components/Editor'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
          Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        groupId: null,
        userId: null,
        postTitle: null,
        postContent: null,
        postType: null,
        postStatus: 0,
        coverUrl: null,
        addressAreaId: null,
        addressDetail: null,
        addressLongitude: null,
        addressLatitude: null,
        viewNum: null,
        starNum: null,
        replyNum: null,
        collectionNum: null,
        shareNum: null,
        goodsNum: null,
        isTop: null,
        isRecommend: null,
        auditReason: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          groupId: [{ required: true, message: this.$t('小组ID，外键{community_group.id}') + this.$t('不能为空'), trigger: 'blur' }],
          userId: [{ required: true, message: this.$t('发布用户ID，外键{user_user.id}') + this.$t('不能为空'), trigger: 'blur' }],
          postTitle: [{ required: true, message: this.$t('帖子标题') + this.$t('不能为空'), trigger: 'blur' }],
          postType: [{ required: true, message: this.$t('帖子类型：10-文字，20-图文，30-视频') + this.$t('不能为空'), trigger: 'change' }],
          postStatus: [{ required: true, message: this.$t('帖子状态：1010-正常，1020-待审核，1030-审核拒绝，1040-已下架') + this.$t('不能为空'), trigger: 'blur' }],
          coverUrl: [{ required: true, message: this.$t('帖子封面URL，图文取首图，视频取封面') + this.$t('不能为空'), trigger: 'blur' }],
          addressAreaId: [{ required: true, message: this.$t('区域ID') + this.$t('不能为空'), trigger: 'blur' }],
          addressDetail: [{ required: true, message: this.$t('详细地址') + this.$t('不能为空'), trigger: 'blur' }],
          viewNum: [{ required: true, message: this.$t('浏览数量') + this.$t('不能为空'), trigger: 'blur' }],
          starNum: [{ required: true, message: this.$t('点赞数量') + this.$t('不能为空'), trigger: 'blur' }],
          replyNum: [{ required: true, message: this.$t('评论数量') + this.$t('不能为空'), trigger: 'blur' }],
          collectionNum: [{ required: true, message: this.$t('收藏数量') + this.$t('不能为空'), trigger: 'blur' }],
          shareNum: [{ required: true, message: this.$t('分享数量') + this.$t('不能为空'), trigger: 'blur' }],
          goodsNum: [{ required: true, message: this.$t('关联商品数量') + this.$t('不能为空'), trigger: 'blur' }],
          isTop: [{ required: true, message: this.$t('是否置顶：1-是，0-否') + this.$t('不能为空'), trigger: 'blur' }],
          isRecommend: [{ required: true, message: this.$t('是否推荐：1-是，0-否') + this.$t('不能为空'), trigger: 'blur' }],
          auditReason: [{ required: true, message: this.$t('审核/下架原因') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        groupId: null,
        userId: null,
        postTitle: null,
        postContent: null,
        postType: null,
        postStatus: 0,
        coverUrl: null,
        addressAreaId: null,
        addressDetail: null,
        addressLongitude: null,
        addressLatitude: null,
        viewNum: null,
        starNum: null,
        replyNum: null,
        collectionNum: null,
        shareNum: null,
        goodsNum: null,
        isTop: null,
        isRecommend: null,
        auditReason: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupPost({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupPost(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupPost(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
